'use client';

import { useLingui } from '@lingui/react';
// Import renderer, note that introducing the CanvasRenderer or SVGRenderer is a required step
import { Box } from '@mui/material';
// import the core library.
import ReactEChartsCore from 'echarts-for-react/lib/core';
// Import charts, all with Chart suffix
import { LineChart } from 'echarts/charts';
// import components, all suffixed with Component
import { GridComponent, TooltipComponent } from 'echarts/components';
// Import the echarts core module, which provides the necessary interfaces for using echarts.
import * as echarts from 'echarts/core';
import {
//   CanvasRenderer,
SVGRenderer } from 'echarts/renderers';
import { type FC, useMemo } from 'react';
// import { SecondCircleResultSchemaT } from 'src/utils/fetch-helio-second-circle-items';

type Props = {
  historicalData?: {
    created_at: string;
    adapted: {
      d: number;
      i: number;
      s: number;
      c: number;
    };
    natural: {
      d: number | null;
      i: number | null;
      s: number | null;
      c: number | null;
    };
  }[];
  width?: string;
  height?: string;
  isBlury?: boolean;
  showNatural?: boolean;
};

// Register the required components
echarts.use([TooltipComponent, GridComponent, LineChart, SVGRenderer]);
export const AuraDiscHistoryLinesGraph: FC<Props> = (props: Props) => {
  const {
    historicalData,
    isBlury = false,
    showNatural = false,
    width = '800px',
    height = '540px'
  } = props;
  const blurFilter = isBlury ? 'blur(4px)' : 'blur(0)';
  const {
    i18n
  } = useLingui();
  const formattedDate = (date?: string) => {
    return date ? new Date(date).toLocaleDateString(i18n.locale as Intl.LocalesArgument) : null;
  };
  const option = useMemo(() => ({
    title: {
      text: 'Stacked Line'
    },
    tooltip: {
      trigger: 'axis',
      valueFormatter: (value: string) => `${value}%`
    },
    legend: {
      data: ['D', 'I', 'S', 'C']
    },
    grid: {
      left: '0',
      right: '32px',
      bottom: '0',
      containLabel: true
    },
    toolbox: {
      feature: {
        saveAsImage: {}
      }
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: historicalData?.map(data => formattedDate(data.created_at)),
      axisLabel: {
        show: true,
        fontWeight: 'bolder'
      }
    },
    yAxis: {
      type: 'value',
      min: 0,
      max: 100,
      interval: 10,
      axisLabel: {
        formatter: (value: string, index: number) => {
          return index === 0 || index === 3 || index === 5 || index === 7 || index === 10 ? `${value}%` : null;
        }
      }
    },
    series: [{
      name: 'D',
      type: 'line',
      data: showNatural ? historicalData?.map(data => data.natural.d) : historicalData?.map(data => data.adapted.d),
      color: '#FF3333'
    }, {
      name: 'I',
      type: 'line',
      data: showNatural ? historicalData?.map(data => data.natural.i) : historicalData?.map(data => data.adapted.i),
      color: '#FCB91B'
    }, {
      name: 'S',
      type: 'line',
      data: showNatural ? historicalData?.map(data => data.natural.s) : historicalData?.map(data => data.adapted.s),
      color: '#15CB31'
    }, {
      name: 'C',
      type: 'line',
      data: showNatural ? historicalData?.map(data => data.natural.c) : historicalData?.map(data => data.adapted.c),
      color: '#2490D9'
    }]
  }), [historicalData]);
  return <Box component="div" position="relative" width={width} height={height} sx={{
    filter: blurFilter
  }} data-sentry-element="Box" data-sentry-component="AuraDiscHistoryLinesGraph" data-sentry-source-file="index.tsx">
      <ReactEChartsCore echarts={echarts} option={option} notMerge={true} lazyUpdate={true} theme={'theme_name'} style={{
      height: '100%',
      width: '100%',
      position: 'relative'
    }} opts={{}} data-sentry-element="ReactEChartsCore" data-sentry-source-file="index.tsx" />
    </Box>;
};